/**
 * `value` when it holds visible text, otherwise `undefined` — so a display
 * fallback chain can use `??` and still skip blank strings a server may send
 * for an unnamed sphere or factor.
 */
export function nonBlank(value: string | null | undefined): string | undefined {
  return value?.trim() ? value : undefined;
}
